import StyleOption from './StyleOption';

export default StyleOption;